module.exports = __webpack_public_path__ + "static/media/gobid-logo-negativo.371841eb.png";